import React, { useState, useEffect } from 'react';
import { Box, ChakraProvider, extendTheme } from '@chakra-ui/react';
import { Routes, Route, Navigate } from 'react-router-dom';
import StakeholderDeck from './components/StakeholderDeck';
import AdminContainer from './admin/AdminContainer';
import LoginHUD from './components/LoginHUD';
import WelcomeStartScreen from './components/WelcomeStartScreen';
import { UserProvider } from './context/UserContext';
import { CaptionsProvider } from './context/CaptionsContext';
import { NavigationProvider } from './context/NavigationContext';
import { AuthProvider } from './context/AuthContext';
import ProtectedRoute from './components/ProtectedRoute';
import { AudioProvider } from './context/AudioContext';
import { methodistTheme } from './styles/theme';
import AdminLoginPage from './admin/Login/AdminLoginPage';

const theme = extendTheme(methodistTheme);

export default function App() {
  const [showWelcome, setShowWelcome] = useState(true);
  const [presentationStarted, setPresentationStarted] = useState(false);

  useEffect(() => {
    console.log('App mounted');
    console.log('localStorage jimi_firstName:', localStorage.getItem('jimi_firstName'));
    console.log('localStorage jimi_acknowledged:', localStorage.getItem('jimi_acknowledged'));
  }, []);

  const handleStartPresentation = () => {
    console.log('Starting presentation from App.tsx');
    setShowWelcome(false);
    setPresentationStarted(true);
    // Add a small delay to ensure smooth transition
    setTimeout(() => {
      const event = new CustomEvent('presentationStarted', {
        detail: { startingSlideIndex: 1 } // Start at index 1 (Presenter Bio) since index 0 is now WelcomeStartScreen
      });
      window.dispatchEvent(event);
      console.log('Presentation started event dispatched with startingSlideIndex: 1');
    }, 300);
  };

  const handleBackToWelcome = () => {
    setShowWelcome(true);
    setPresentationStarted(false);
  };

  return (
    <AuthProvider>
      <UserProvider>
        <NavigationProvider>
          <CaptionsProvider initialShowCaptions={true}>
            <AudioProvider>
              <ChakraProvider theme={theme}>
                <Box height="100%" width="100%" overflow="hidden" margin="0" padding="0" display="flex" justifyContent="center" alignItems="center">
                  <Routes>
                    <Route path="/login" element={<LoginHUD />} />
                    <Route 
                      path="/presentation" 
                      element={
                        <ProtectedRoute>
                          {showWelcome ? (
                            <WelcomeStartScreen onStart={handleStartPresentation} />
                          ) : (
                            <StakeholderDeck 
                              presentationStarted={presentationStarted}
                              startingSlideId="presenter-bio"
                              onBackToWelcome={handleBackToWelcome}
                            />
                          )}
                        </ProtectedRoute>
                      } 
                    />
                    <Route path="/admin/login" element={<AdminLoginPage />} />
                    <Route 
                      path="/admin/*" 
                      element={
                        <ProtectedRoute>
                          <AdminContainer />
                        </ProtectedRoute>
                      } 
                    />
                    <Route path="/" element={<Navigate to="/login" replace />} />
                    <Route path="*" element={<Navigate to="/login" replace />} />
                  </Routes>
                </Box>
              </ChakraProvider>
            </AudioProvider>
          </CaptionsProvider>
        </NavigationProvider>
      </UserProvider>
    </AuthProvider>
  );
}
